import { Check } from 'lucide-react'
import { MockShell } from './MockShell'

const OPTIONS = [
  { name: 'Göni', price: '€ 1,413', sub: '1 sowadyjy · 14 sag ýolda', accepted: true },
  { name: 'Geçiş · Berlin', price: '€ 1,295', sub: '1 sowadyjy + xdock · 18 sag', accepted: false },
  { name: 'Bölünen · 2 ulag', price: '€ 1,620', sub: '2 ýapyk furgon · 14 sag', accepted: false },
]

export function ClientShareMock() {
  return (
    <MockShell title="routenroute.com/o/q-2417 · Müşderi görünişi">
      <div className="p-5">
        <div className="mb-5">
          <p className="text-overline text-muted-foreground mb-1">Route and Route-dan teklip</p>
          <h4 className="text-h3 text-foreground">Rotterdam → Warsaw · Ýüklemek dş</h4>
          <p className="text-[12px] text-muted-foreground mt-1">
            Size laýyk warianty saýlap, aşakda jogap beriň.
          </p>
        </div>

        <div className="space-y-2">
          {OPTIONS.map((o) => (
            <div
              key={o.name}
              className={
                'rounded-xl border p-4 flex items-center justify-between gap-3 ' +
                (o.accepted
                  ? 'border-positive/40 bg-positive/5'
                  : 'border-border bg-background')
              }
            >
              <div className="flex items-center gap-3">
                <div
                  className={
                    'w-5 h-5 rounded-full border flex items-center justify-center ' +
                    (o.accepted
                      ? 'border-positive bg-positive text-primary-foreground'
                      : 'border-border')
                  }
                >
                  {o.accepted && <Check className="w-3 h-3" />}
                </div>
                <div>
                  <p className="text-[13px] font-semibold">{o.name}</p>
                  <p className="text-[11px] text-muted-foreground">{o.sub}</p>
                </div>
              </div>
              <span className="tnum text-[14px] font-semibold">{o.price}</span>
            </div>
          ))}
        </div>

        <div className="mt-5 rounded-xl border border-border p-3 bg-muted/30">
          <p className="text-[12px] text-foreground">
            <span className="font-semibold">Jan · Acme</span>{' '}
            <span className="text-muted-foreground">— Göni bilen geçýäs. Ýüklemek dş 06:00 tassyklandy.</span>
          </p>
        </div>
      </div>
    </MockShell>
  )
}
